/* [PATCH vod-privzeti-dim-fe v1] Nastavitve -> Ostalo (prejeti in izdani): "Privzeto SM ob prenosu".
   Ce je vklopljeno, Opal (VOD) prenos na kontih razreda 4 in 7 PRAZEN SM / projekt nadomesti s privzeto sifro.
   Vrednost "0" ni prazna in ostane. Shranjeni dokumenti se ne spreminjajo (samo izvozna datoteka).
   Privzeto IZKLOPLJENO = dosedanje vedenje. Shranjuje se SPROTI (PUT /profil/{cid}; exclude_none).
   Klon VezaInternaKartica.tsx. */
import { useState, useEffect } from 'react';
import { api } from '../../lib/api';
import { Layers } from 'lucide-react';

export function PrivzetiSmKartica({ companyId }: { companyId: string }) {
  const [vklop, setVklop] = useState(false);
  const [sm, setSm] = useState('');
  const [projekt, setProjekt] = useState('');
  const [spor, setSpor] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    api.get(`/profil/${companyId}`)
      .then(r => {
        setVklop(r.data?.vod_privzeti_dim === true);
        setSm(r.data?.vod_privzeti_sm || '');
        setProjekt(r.data?.vod_privzeti_projekt || '');
      })
      .catch(() => {});
  }, [companyId]);

  const shrani = async (polja: Record<string, unknown>, sporocilo: string) => {
    setBusy(true); setSpor('');
    try {
      await api.put(`/profil/${companyId}`, polja);
      setSpor(sporocilo);
      return true;
    } catch {
      setSpor('Napaka pri shranjevanju.');
      return false;
    } finally {
      setBusy(false);
    }
  };

  const preklopi = async () => {
    if (busy) return;
    const novo = !vklop;
    if (await shrani({ vod_privzeti_dim: novo }, novo ? 'Shranjeno: vklopljeno.' : 'Shranjeno: izklopljeno.')) setVklop(novo);
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-6 max-w-2xl">
      <div className="flex items-center gap-3 mb-1">
        <div className="w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-950 flex items-center justify-center text-blue-600 dark:text-blue-400">
          <Layers className="w-5 h-5" />
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 dark:text-white">Privzeto SM ob prenosu</h2>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Ob prenosu v Opal se na kontih razreda 4 in 7 prazno stroškovno mesto in prazen projekt nadomestita s
            spodnjo šifro. Vrednost 0 ni prazna in ostane. Knjižbe na računih se ne spremenijo, samo prenosna datoteka.
            Velja za prejete in izdane račune.
          </p>
        </div>
      </div>
      <div className="mt-4 flex items-start gap-3">
        <button
          type="button"
          onClick={preklopi}
          disabled={busy}
          role="switch"
          aria-checked={vklop}
          className={`relative w-12 h-6 rounded-full transition-colors shrink-0 ${vklop ? 'bg-emerald-500' : 'bg-gray-300 dark:bg-gray-700'} ${busy ? 'opacity-60' : ''}`}
        >
          <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-white transition-all ${vklop ? 'left-6' : 'left-0.5'}`} />
        </button>
        <div className="text-sm font-medium text-gray-900 dark:text-white">
          {vklop ? 'Privzeto SM se dopolni ob prenosu' : 'Prenos je enak kot doslej'}
        </div>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-4">
        <label className="text-xs text-gray-600 dark:text-gray-400">
          Privzeto stroškovno mesto
          <input
            type="text" maxLength={10} value={sm}
            onChange={e => setSm(e.target.value)}
            onBlur={() => shrani({ vod_privzeti_sm: sm.trim() }, 'Shranjeno: privzeto SM.')}
            placeholder="npr. 0001"
            className="mt-1 w-full rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 py-1.5 text-sm"
          />
        </label>
        <label className="text-xs text-gray-600 dark:text-gray-400">
          Privzeti projekt
          <input
            type="text" maxLength={10} value={projekt}
            onChange={e => setProjekt(e.target.value)}
            onBlur={() => shrani({ vod_privzeti_projekt: projekt.trim() }, 'Shranjeno: privzeti projekt.')}
            placeholder="npr. 0001"
            className="mt-1 w-full rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 py-1.5 text-sm"
          />
        </label>
      </div>
      {spor && <p className="text-[11px] text-gray-500 mt-2">{spor}</p>}
      <p className="text-[11px] text-gray-500 mt-3">Nastavitev se shrani sproti (neodvisno od gumba Shrani). Prazno polje = ta dimenzija se ne dopolnjuje.</p>
    </div>
  );
}
